(() => {
  const selector = 'img[data-pf-src]';
  const observed = new WeakSet();
  const loadImage = (image) => {
    if (!image?.dataset.pfSrc) return;
    image.loading = 'eager';
    if (image.dataset.pfSrcset) image.srcset = image.dataset.pfSrcset;
    image.src = image.dataset.pfSrc;
    delete image.dataset.pfSrc;
    delete image.dataset.pfSrcset;
  };
  const observer = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadImage(entry.target);
        observer.unobserve(entry.target);
        // Prepare the next two cards before a moving strip reveals them.
        let card = entry.target.parentElement.nextElementSibling;
        for (let index = 0; card && index < 2; index += 1) {
          loadImage(card.querySelector(selector));
          card = card.nextElementSibling;
        }
      });
    }, {rootMargin: '600px 0px'})
    : null;

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((image) => {
      if (observed.has(image)) return;
      observed.add(image);
      if (observer) observer.observe(image);
      else loadImage(image);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  } else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
